export default __webpack_public_path__ + "static/media/void.30b49b2b.png";